import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink, Navigate } from 'react-router-dom';
import { t } from '@/core/localization';
import { store } from '@/warehouse/store';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
import { initInvoices } from './thunks';
const { rootPath, getLinkTo, title, groups } = appSections.stockReceipt;
export const stockReceiptRoutes = [
    { path: rootPath, element: _jsx(Navigate, { to: "invoices", replace: true }) },
    {
        path: rootPath,
        lazy: async () => {
            const { StockReceiptContainer } = await import('@/warehouse/modules/stockReceipt');
            return {
                element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(StockReceiptContainer, {}) })),
            };
        },
        handle: {
            crumb: ({ params: { locationId } }) => _jsx(NavLink, { to: getLinkTo(locationId), children: title }),
        },
        children: [
            {
                path: ':tab',
                lazy: async () => {
                    const { StockReceipt } = await import('@/warehouse/modules/stockReceipt');
                    return { Component: StockReceipt };
                },
                loader: () => store.dispatch(initInvoices()),
                handle: {
                    crumb: ({ params: { locationId, tab } }) => (_jsx(NavLink, { to: `${getLinkTo(locationId)}/${tab}`, children: tab === 'invoices' ? t('incoming.label') : tab === 'verification' ? t('verification.label') : 'UNKNOWN' })),
                },
            },
            {
                path: ':tab/:invoiceId',
                lazy: async () => {
                    const { Invoice } = await import('@/warehouse/modules/stockReceipt/components/Invoice');
                    return { Component: Invoice };
                },
                handle: {
                    crumb: ({ params: { locationId, tab } }) => (_jsx(NavLink, { to: `${getLinkTo(locationId)}/${tab}`, relative: "path", children: t('incoming.label') })),
                },
            },
        ],
    },
];
